import React from 'react';
import _ from 'lodash';
import Auth from './Auth';
import DropdownSelector from './dropdowns/DropdownSelector';
import PrimeContractorToggle from './toggle/PrimeContractorToggle';
import FieldContractorUserService from '../services/FieldContractorUsers';
import FieldGroupService from '../services/FieldGroups';
import FieldItemService from '../services/FieldItems';
import FieldItemInputService from '../services/FieldItemInputs';
import FieldTreeService from '../services/FieldTrees';
import {
  USER_ROLES,
  REQUEST_PARAMS,
  API_FLAG,
  FIELD_ITEM_LISTS,
  WORKER_TYPES,
} from '../utilities/constants';
import { matchDefaultTo } from '../utilities/commonUtil';

// TODO: code split to constants.js
const WORK_APPROVAL_STATUS = {
  NotApproved: 0,
  Approved: 1,
};

/**
 * @description 作業予定、作業実績一覧画面_検索条件フォーム
 */
class WorkSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFormOpen: false,
      isFirstFormOpened: false,
      itemNames: { A: '', B: '', C: '', D: '' },
    };

    this.handleSearchFormToggle = this.handleSearchFormToggle.bind(this);
    this.handleSetSearchParam = this.handleSetSearchParam.bind(this);
    this.handleResetSearchParam = this.handleResetSearchParam.bind(this);
    this.clearFlag = false;
  }

  componentDidMount() {
    FieldItemInputService.itemNames(this.props.fieldId).then(itemNames =>
      this.setState({ itemNames })
    );
  }

  componentDidUpdate() {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
  }

  handleSearchFormToggle = () => {
    if (!this.state.isFirstFormOpened && !this.state.isFormOpen) {
      // 1回でも開いたかどうかを保持する
      this.setState({
        isFirstFormOpened: true,
      });
    }
    this.setState({
      isFormOpen: !this.state.isFormOpen,
    });
  };

  handleSetSearchParam = () => {
    const { onSetSearchParam, isLoading } = this.props;
    if (isLoading) return;

    onSetSearchParam();
  };

  handleResetSearchParam = () => {
    // 1回でも開いてない場合は検索条件ドロップダウンをクリア・更新する必要ない
    if (
      (!this.state.isFirstFormOpened && !this.state.isFormOpen) ||
      this.props.isLoading
    ) {
      return;
    } else {
      this.clearFlag = true;
      const SearchDropdown = document.querySelectorAll('.SearchDropdown');
      _.each(SearchDropdown, dropDown => {
        dropDown.value = '';
      });
      const { onResetSearchParam } = this.props;
      onResetSearchParam();
    }
  };

  // 検索条件(保存用)セット
  handleSetTempSearchParam = (name, value) => {
    const { onSetTempSearchParam } = this.props;
    onSetTempSearchParam(name, value);
  };

  // 検索条件(保存用)の変更(Toggle)
  handleToggleTempSearchParams = (name, value) => {
    const toggledValue = parseInt(value, 10) === 0 ? '1' : '0';
    this.handleSetTempSearchParam(name, toggledValue);
  };

  render() {
    const uniqueId = _.uniqueId();
    const {
      scheduleFlag,
      tempSearchParams,
      workTotal,
      fieldId,
      isConferenceMode = false,
      options,
      loaded,
    } = this.props;
    const { isFormOpen, isFirstFormOpened, itemNames } = this.state;
    return (
      <div className='schedulelist__searchform'>
        <div className='search-form'>
          <div className='search-form__header'>
            <div className='search-form__title'>
              検索条件（検索結果
              <span className='bold'>{workTotal}</span>件)
            </div>
            <button
              id='accordion-toggle'
              className={`accordion__btn${isFormOpen ? ' show' : ''}`}
              onClick={() => {
                this.handleSearchFormToggle();
              }}
            />
            <button
              className='btn-text--sm'
              onClick={() => {
                this.handleResetSearchParam();
              }}
            >
              検索条件クリア
            </button>
          </div>
          <div
            id='search-form-accordion'
            className={`accordion${isFormOpen ? ' show' : ''}`}
          >
            {/*ドロップダウンリストはレンダリングされるとAPIをコールするので最初に開くまでレンダリングを遅らせる。*/}
            {/*1度開いた後はレンダリングし続ける。*/}
            {isFirstFormOpened && (
              <div className='search-form__body'>
                <div className='form form--search-form'>
                  <div className='form__group flex-wrap'>
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>
                          {this.props.usePartnerCompanyApprovalFlag
                            ? '元請会社承認'
                            : 'ステータス'}
                        </span>
                      </div>
                      <div className='form-element__list'>
                        <div className='element__item'>
                          <label
                            htmlFor={`is_approved_1${uniqueId}`}
                            className='radio'
                          >
                            <input
                              id={`is_approved_1${uniqueId}`}
                              type='radio'
                              name='is_approved'
                              value={0}
                              checked={
                                parseInt(tempSearchParams.is_approved, 10) ===
                                WORK_APPROVAL_STATUS.NotApproved
                              }
                              onChange={e =>
                                this.handleSetTempSearchParam(
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                            <i className='i-2x' />
                            <span>未承認</span>
                          </label>
                        </div>
                        <div className='element__item'>
                          <label
                            htmlFor={`is_approved_2${uniqueId}`}
                            className='radio'
                          >
                            <input
                              id={`is_approved_2${uniqueId}`}
                              type='radio'
                              name='is_approved'
                              value={1}
                              checked={
                                parseInt(tempSearchParams.is_approved, 10) ===
                                WORK_APPROVAL_STATUS.Approved
                              }
                              onChange={e =>
                                this.handleSetTempSearchParam(
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                            <i className='i-2x' />
                            <span>承認済</span>
                          </label>
                        </div>
                        <PrimeContractorToggle>
                          <div className='element__item'>
                            <label
                              htmlFor={`not_approved_by_me_flag-${uniqueId}`}
                              className='checkbox'
                            >
                              <input
                                id={`not_approved_by_me_flag-${uniqueId}`}
                                type='checkbox'
                                name='not_approved_by_me_flag'
                                value={matchDefaultTo(
                                  tempSearchParams.not_approved_by_me_flag,
                                  [undefined],
                                  API_FLAG.Off
                                )}
                                checked={
                                  tempSearchParams.not_approved_by_me_flag ===
                                  String(API_FLAG.On)
                                }
                                onClick={e =>
                                  this.handleToggleTempSearchParams(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-2x' />
                              <span>自分が未承認のみ表示</span>
                            </label>
                          </div>
                        </PrimeContractorToggle>
                      </div>
                    </div>
                    {this.props.usePartnerCompanyApprovalFlag && (
                      <div className='form-element'>
                        <div className='form-element__label'>
                          <span className='label'>{`協力会社${
                            this.props.partnerApprovalName
                          }`}</span>
                        </div>
                        <div className='form-element__list'>
                          <div className='element__item'>
                            <label
                              htmlFor={`is_partner_company_approved_1-${uniqueId}`}
                              className='radio'
                            >
                              <input
                                id={`is_partner_company_approved_1-${uniqueId}`}
                                type='radio'
                                name='is_partner_company_approved'
                                value={API_FLAG.Off}
                                checked={
                                  tempSearchParams.is_partner_company_approved ===
                                  String(API_FLAG.Off)
                                }
                                onChange={e =>
                                  this.handleSetTempSearchParam(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-2x' />
                              <span>{`未${
                                this.props.partnerApprovalName
                              }`}</span>
                            </label>
                          </div>
                          <div className='element__item'>
                            <label
                              htmlFor={`is_partner_company_approved_2-${uniqueId}`}
                              className='radio'
                            >
                              <input
                                id={`is_partner_company_approved_2-${uniqueId}`}
                                type='radio'
                                name='is_partner_company_approved'
                                value={API_FLAG.On}
                                checked={
                                  tempSearchParams.is_partner_company_approved ===
                                  String(API_FLAG.On)
                                }
                                onChange={e =>
                                  this.handleSetTempSearchParam(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-2x' />
                              <span>{`${
                                this.props.partnerApprovalName
                              }済`}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    {!isConferenceMode && (
                      <div className='form-element'>
                        <div className='form-element__label'>
                          <span className='label'>契約</span>
                        </div>
                        <div className='form-element__list'>
                          <div className='element__item'>
                            <label
                              htmlFor={`dayworker_type_1${uniqueId}`}
                              className='radio'
                            >
                              <input
                                id={`dayworker_type_1${uniqueId}`}
                                type='radio'
                                name='dayworker_type'
                                value={WORKER_TYPES.contractor.id}
                                checked={
                                  parseInt(tempSearchParams.dayworker_type, 10) ===
                                  WORKER_TYPES.contractor.id
                                }
                                onChange={e =>
                                  this.handleSetTempSearchParam(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-2x' />
                              <span>{WORKER_TYPES.contractor.name}</span>
                            </label>
                          </div>
                          <div className='element__item'>
                            <label
                              htmlFor={`dayworker_type_2${uniqueId}`}
                              className='radio'
                            >
                              <input
                                id={`dayworker_type_2${uniqueId}`}
                                type='radio'
                                name='dayworker_type'
                                value={WORKER_TYPES.regular.id}
                                checked={
                                  parseInt(tempSearchParams.dayworker_type, 10) ===
                                  WORKER_TYPES.regular.id
                                }
                                onChange={e =>
                                  this.handleSetTempSearchParam(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-2x' />
                              <span>{WORKER_TYPES.regular.name}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className='form-element'
                      style={
                        this.props.value.field_item_list1_display_flag === 1
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                    >
                      <div className='form-element__label'>
                        <span className='label'>{itemNames.A}</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='a_item_ids'
                          api={params => FieldItemService.list(fieldId, params)}
                          apiParams={{
                            field_id: fieldId,
                            item_list_ids: FIELD_ITEM_LISTS.a.id,
                            limit: REQUEST_PARAMS.parentLimit,
                          }}
                          sorted={data => data} // ソートさせないための処理
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.a_item_ids}
                          keyName='name'
                          valueName='id'
                          apiBindDataKey={'field_item_a_lists'}
                          onSelect={(name, values) =>
                            this.handleSetTempSearchParam(name, values)
                          }
                          options={options.field_item_a_lists}
                          loaded={loaded}
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <div
                      className='form-element'
                      style={
                        this.props.value.field_item_list2_display_flag === 1
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                    >
                      <div className='form-element__label'>
                        <span className='label'>{itemNames.B}</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='b_item_ids'
                          api={params => FieldItemService.list(fieldId, params)}
                          apiParams={{
                            field_id: fieldId,
                            item_list_ids: FIELD_ITEM_LISTS.b.id,
                            limit: REQUEST_PARAMS.parentLimit,
                          }}
                          sorted={data => data} // ソートさせないための処理
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.b_item_ids}
                          keyName='name'
                          valueName='id'
                          apiBindDataKey={'field_item_b_lists'}
                          onSelect={(name, values) =>
                            this.handleSetTempSearchParam(name, values)
                          }
                          options={options.field_item_b_lists}
                          loaded={loaded}
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <div
                      className='form-element'
                      style={
                        this.props.value.field_item_list3_display_flag === 1
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                    >
                      <div className='form-element__label'>
                        <span className='label'>{itemNames.C}</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='c_item_ids'
                          api={params => FieldItemService.list(fieldId, params)}
                          apiParams={{
                            field_id: fieldId,
                            item_list_ids: FIELD_ITEM_LISTS.c.id,
                            limit: REQUEST_PARAMS.parentLimit,
                          }}
                          sorted={data => data} // ソートさせないための処理
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.c_item_ids}
                          keyName='name'
                          valueName='id'
                          apiBindDataKey={'field_item_c_lists'}
                          onSelect={(name, values) =>
                            this.handleSetTempSearchParam(name, values)
                          }
                          options={options.field_item_c_lists}
                          loaded={loaded}
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <div
                      className='form-element'
                      style={
                        this.props.value.field_item_list4_display_flag === 1
                          ? { display: 'block' }
                          : { display: 'none' }
                      }
                    >
                      <div className='form-element__label'>
                        <span className='label'>{itemNames.D}</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='d_item_ids'
                          api={params => FieldItemService.list(fieldId, params)}
                          apiParams={{
                            field_id: fieldId,
                            item_list_ids: FIELD_ITEM_LISTS.d.id,
                            limit: REQUEST_PARAMS.parentLimit,
                          }}
                          sorted={data => data} // ソートさせないための処理
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.d_item_ids}
                          keyName='name'
                          valueName='id'
                          apiBindDataKey={'field_item_d_lists'}
                          onSelect={(name, values) =>
                            this.handleSetTempSearchParam(name, values)
                          }
                          options={options.field_item_d_lists}
                          loaded={loaded}
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>元請担当者</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='manager_user_ids'
                          api={params =>
                            FieldContractorUserService.list(fieldId, params)
                          }
                          apiParams={{
                            field_id: fieldId,
                            limit: REQUEST_PARAMS.parentLimit,
                          }}
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.manager_user_ids}
                          keyName='user_name'
                          valueName='user_id'
                          apiBindDataKey={'field_contractor_users'}
                          onSelect={(name, values) =>
                            this.handleSetTempSearchParam(name, values)
                          }
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>グループ</span>
                      </div>
                      <div className='form-element__list'>
                        <DropdownSelector
                          className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                          label='選択してください'
                          multiple={true}
                          selectorName='field_group_ids'
                          api={params =>
                            // 検索専用のグループ一覧
                            FieldGroupService.listForSearch(fieldId, params)
                          }
                          apiParams={{
                            limit: REQUEST_PARAMS.parentLimit,
                          }}
                          apiSearchKey='name'
                          selectedValues={tempSearchParams.field_group_ids}
                          keyName='name'
                          valueName='id'
                          apiBindDataKey={'field_groups'}
                          onSelect={(name, values) => {
                            this.handleSetTempSearchParam(name, values);
                          }}
                          clearFlag={this.clearFlag}
                        />
                      </div>
                    </div>
                    <Auth
                      approvedRoles={[
                        USER_ROLES.prime,
                        USER_ROLES.branch,
                        USER_ROLES.manager,
                      ]}
                    >
                      <div className='form-element'>
                        <div className='form-element__label'>
                          <span className='label'>協力会社</span>
                        </div>
                        <div className='form-element__list'>
                          <DropdownSelector
                            className='--col-xs-12 --col-md-12 --col-lg-8 --col-xl-8'
                            label='選択してください'
                            multiple={true}
                            selectorName='field_tree_ids'
                            api={params =>
                              FieldTreeService.selectableCompaniesList(
                                fieldId,
                                params
                              )
                            }
                            offset={REQUEST_PARAMS.parentLimit}
                            apiParams={{
                              field_id: fieldId,
                              limit: REQUEST_PARAMS.parentLimit,
                              show_finished: API_FLAG.On,
                              show_no_foreman: API_FLAG.On,
                            }}
                            limit={REQUEST_PARAMS.parentLimit}
                            apiSearchKey='name'
                            selectedValues={tempSearchParams.field_tree_ids}
                            keyName='name'
                            valueName='field_tree_id'
                            apiBindDataKey={'companies'}
                            onSelect={(name, values) => {
                              this.handleSetTempSearchParam(name, values);
                            }}
                            widthClass='dropdown__item--wide'
                            clearFlag={this.clearFlag}
                            exceptionAllLoadedLimit={true}
                          />
                        </div>
                      </div>
                    </Auth>
                    {/* 実績時のみ表示 */}
                    {parseInt(scheduleFlag, 10) === 0 && (
                      <div className='form-element'>
                        <div className='form-element__list'>
                          <div className='element__item'>
                            <label
                              htmlFor={`dayworker_not_exist_flag-${uniqueId}`}
                              className='checkbox'
                            >
                              <input
                                id={`dayworker_not_exist_flag-${uniqueId}`}
                                type='checkbox'
                                name='dayworker_not_exist_flag'
                                value={
                                  tempSearchParams.dayworker_not_exist_flag || 0
                                }
                                checked={
                                  parseInt(
                                    tempSearchParams.dayworker_not_exist_flag,
                                    10
                                  ) === 1
                                }
                                onClick={e =>
                                  this.handleToggleTempSearchParams(
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              <i className='i-square i-2x' />
                              <span>人工未入力のグループのみを表示</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className='form-element'>
                      <div className='form-element__label'>
                        <span className='label'>別途業者</span>
                      </div>
                      <div className='form-element__list'>
                        <div className='element__item'>
                          <label
                            htmlFor={`private_partner_company_flag_0${uniqueId}`}
                            className='radio'
                          >
                            <input
                              id={`private_partner_company_flag_0${uniqueId}`}
                              type='radio'
                              name='private_partner_company_flag'
                              value={1}
                              checked={
                                parseInt(
                                  tempSearchParams.private_partner_company_flag,
                                  10
                                ) === 1
                              }
                              onChange={e =>
                                this.handleSetTempSearchParam(
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                            <i className='i-2x' />
                            <span>別途業者のみを表示</span>
                          </label>
                        </div>
                        <div className='element__item'>
                          <label
                            htmlFor={`private_partner_company_flag_1${uniqueId}`}
                            className='radio'
                          >
                            <input
                              id={`private_partner_company_flag_1${uniqueId}`}
                              type='radio'
                              name='private_partner_company_flag'
                              value={0}
                              checked={
                                parseInt(
                                  tempSearchParams.private_partner_company_flag,
                                  10
                                ) === 0
                              }
                              onChange={e =>
                                this.handleSetTempSearchParam(
                                  e.target.name,
                                  e.target.value
                                )
                              }
                            />
                            <i className='i-2x' />
                            <span>別途業者を除く</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className='form-element'>
                      <div className='form-element__list'>
                        <button
                          className='btn-fixedsize--stay search-form__btn--align-to-element'
                          onClick={this.handleSetSearchParam}
                        >
                          検索
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default WorkSearchForm;



// WEBPACK FOOTER //
// ./src/components/WorkSearchForm.jsx